<template>
  <v-card title="发票查询">
    <div class="grid-demo">
      <v-more-panel>
        <v-form slot="form">
          <v-form-item label="开票日期">
            <v-date-picker v-model="options.kprqq"></v-date-picker>
            -
            <v-date-picker v-model="options.kprqz"></v-date-picker>
          </v-form-item>
          <v-form-item label="类型"
            ><v-select
              style="width: 100px"
              v-model="options.zt"
              :data="zt_options"
            ></v-select
          ></v-form-item>
          <v-form-item label="发票号码">
            <v-input placeholder="" v-model="options.fphm"></v-input>
          </v-form-item>
          <v-form-item label="发票代码">
            <v-input placeholder="" v-model="options.fpdm"></v-input>
          </v-form-item>
        </v-form>
        <v-form-item>
          <v-button type="primary" icon="search" @click="findList()"
            ><span>查询</span></v-button
          >
        </v-form-item>
      </v-more-panel>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      ref="xTable"
      :data="tableData"
      :loading="loading"
      stripe
      highlight-current-row
      highlight-hover-row
    >
      <template v-slot:cz="{ row }">
        <span>
          <!-- 发票状态为正票、代码不为空、未红冲 状态才显示红冲 -->
          <span
            v-show="
              row.zt == '1' && row.fpdm != '' && row.fpzt == '0' ? true : false
            "
          >
            <v-popconfirm
              title="是否红冲此条发票记录?"
              @confirm="hc(row)"
              @cancel="cancel"
              placement="bottom"
            >
              <a class="link" title="红冲"> 红冲 </a>
            </v-popconfirm>
          </span>
          &nbsp;&nbsp;
          <!-- 发票代码不为空显示下载 -->
          <span v-show="row.fphm != undefined && row.fphm != '' ? true : false">
            <a class="link" @click="download(row)" title="下载">
              <!-- <v-icon type="download"></v-icon> -->下载发票
            </a>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
    <vxe-pager
      :current-page="pagination.pageindex"
      :page-size="pagination.pagesize"
      :total="pagination.totalresult"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange"
    ></vxe-pager>
  </v-card>
</template>
<script>
let options = {
  kprqq: "",
  kprqz: "",
  zt: "",
  fphm: "",
  fpdm: "",
};
let pagination = {
  sort: "kprq",
  sorttype: "desc",
  pagesize: 10,
  pageindex: 1,
  totalresult: 1,
};
let zt_options = [
  { value: "1", label: "正票" },
  { value: "2", label: "红票" },
];
export default {
  data() {
    return {
      pagination,
      options,
      zt_options,
      visible: false,
      loading: false,
      message: "",
      tableData: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 450,
        headerAlign: "center",
        toolbarConfig: {

          export: true,
          zoom: true,
          custom: true
        },
        exportConfig: {
          remote: true,
          exportMethod: this.exportMethod,
          types: ['xlsx'],
          modes: ['current']
        },
        columns: [
          {
            field: "rn",
            title: "序号",
            align: "center",
            sortable: true,
          },
          {
            field: "fpdm",
            title: "发票代码",
            align: "center",
            sortable: true,
          },
          {
            field: "fphm",
            title: "发票号码",
            align: "center",
            sortable: true,
          },
          {
            field: "bhsjg",
            title: "不含税金额",
            headerAlign: "center",
            align: "right",
            formatter: "formatNumber",
            sortable: true,
          },
          {
            field: "hsjg",
            title: "含税金额",
            align: "center",
            headerAlign: "center",
            align: "right",
            formatter: "formatNumber",
            sortable: true,
          },
          {
            field: "yfpdm",
            title: "原发票代码",
            align: "center",
            sortable: true,
          },
          {
            field: "yfphm",
            title: "原发票号码",
            align: "center",
            sortable: true,
          },
          {
            field: "zt",
            title: "类型",
            align: "center",
            sortable: true,
            slots: {
              default: ({ row, column }) => {
                let zt = "";
                if (row.zt == "1") {
                  zt = "正票";
                } else {
                  zt = "红票";
                }
                return [<span>{zt}</span>];
              },
            },
          },
          {
            field: "kprq",
            title: "开票日期",
            align: "center",
            sortable: true,
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz",
            },
          },
        ],
      },
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true
      this.$axios
        .get(
          "api/system/fpcx/get-fpcx-list?cx=" + JSON.stringify(this.options),
          {
            params: this.pagination,
          }
        )
        .then((res) => {
          this.tableData = res.data.data;
          this.pagination.totalresult = res.data.total;
          this.loading = false
        });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageindex = currentPage;
      this.pagination.pagesize = pageSize;
      this.findList();
    },
    cancel: function () {
      this.$message.info("取消红冲");
    },
    hc(row) {
      // if(row.fphm.length<20){
      //   this.$message.error("该票种不支持红冲操作!");
      //   return
      // }
      this.visible = false;
      this.$axios
        .get(
          "api/system/interface/fp-fphc?code=" + row.fpdm + "&number=" + row.fphm
        )
        .then((res) => {
          if (res.data.code == "0000") {

            this.$message["success"](res.data.message, 7);

          }
          else {
            this.$message["error"](res.data.message, 7);
          }
        });
      this.findList();
    },

    async download(row) {

      if (row.fpdm != '') {
        try {
          // 假设你的下载API是'/api/download'  
          const response = await this.$axios({
            url: "api/system/interface/fp-xz?code=" + row.fpdm + "&number=" + row.fphm,
            method: 'GET',
            responseType: 'blob', // 重要：告诉axios期望的响应类型  
          });

          // 创建一个Blob URL指向下载的文件  
          const url = window.URL.createObjectURL(new Blob([response.data]));

          // 创建一个a标签来模拟点击下载  
          const link = document.createElement('a');
          link.href = url;

          // 设置下载文件的名称  
          // 注意：这里需要后端在响应头中通过Content-Disposition字段提供文件名，  
          // 或者你可以在这里硬编码文件名  
          if (row.fpdm == "" || row.fpdm == null || row.fpdm == undefined || row.fpdm == "null") {
            link.download = row.fphm + '.pdf';
          } else {
            link.download = row.fpdm + '_' + row.fphm + '.pdf';
          }


          // 模拟点击a标签  
          // document.body.appendChild(link);  
          link.click();

          // 清理  
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('下载文件时出错:', error);
        }
        //  let a = document.createElement("a");
        //   a.href = "api/system/interface/fp-xz?code="+row.fpdm+"&number="+row.fphm;
        //   a.target="_blank"
        //   a.click();
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    exportMethod({ options }) {


      this.$axios({
        method: 'get', url: 'api/system/fpcx/export-file-fpcx?sheetname=' + options.sheetName + '&cx=' +
          JSON.stringify(this.options) + '&pageindex=' + this.pagination.pageindex + '&pagesize=' + this.pagination.pagesize, responseType: 'blob'
      }).then((res) => {
        debugger
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel;charset=utf-8;" });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = options.filename + ".xlsx"; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
        this.spinning = false

      });
    }

  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/ywgl/fpcx.vue